<gbc-breadcrumb [pageInfo]="pageInfo"></gbc-breadcrumb>
<div class="header-container">
  <div class="header">
    @if (pageInfo.parent) {
      <div class="header-button-container">
        <a class="header-button" [routerLink]="pageInfo.parent.link"><img src="./assets/svgs/back.svg" alt="Back" /></a>
      </div>
    }

    <div class="header-headline-container">
      <h2 class="header-headline">
        {{ pageInfo.title | async }}
        @if (buttons && buttons.length) {
          <div class="menu">
            <div class="menu-wrapper" [ngClass]="{ 'menu-open': menuOpen }">
              <button class="menu-button" gbc-text-button (click)="menuOpen = !menuOpen">
                <img alt="More" src="./assets/svgs/menu-more.svg" />
              </button>
              @if (menuOpen) {
                <div class="menu-buttons">
                  <ng-content select="[gbc-page-header-actions]"></ng-content>
                </div>
              }
            </div>
          </div>
        }
      </h2>
      @for (subtitle of pageInfo.subtitles; track subtitle) {
        @if (subtitle) {
          <p class="header-subheader">{{ subtitle | async }}</p>
        }
      }
    </div>
    <div class="header-button-container">
      <div>
        <ng-content select="[gbc-page-header-right]"></ng-content>
      </div>
    </div>
  </div>
</div>
